import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from "axios"

Vue.use(Vuex)

const Store = new Vuex.Store({
  plugins: [createPersistedState()],

  state: {
    token: null,
    lang: null,
    tokenExpires: null,
    companyName: null,
    privileges: null,
    personLogin: {
      personName: null,
      email: null,
      isArchival: null,
      idx: null,
    },
    isLogged: null,
    
    axiosHeader: {
      headers: {
        Authorization: null,
      }    
    },
    sessionAuthoriseResult:{
      Authorization: null,
    },
    screenOrientation: null,
  },

  actions: {
    changeLang(context){
      context.commit('chageLang')
    },
    login(context, user) {
      return new Promise((resolve, reject) => {
        let data = {
          login: user.login,
          password: user.password,
        };
        axios
          .post(window.API.Authentications, data)
          .then(response => {
            if (response.data.isLogged) {
              sessionStorage.setItem("TPSession", JSON.stringify(response.data.token));
              context.commit('updateAuthorization', response.data);
              context.commit('updateAxiosHeader', "Bearer " + response.data.token);
              context.commit('updateAuthoriseResult', "logged");
            }
            else
            {
              context.commit('updateAuthoriseResult', "notlogged");
            }
            resolve(this.sessionAuthoriseResult);
          })
          .catch(errors => {
            reject(errors)
          }); 
      })
    },
    logout(context) {
      return new Promise((resolve, reject) => {
        sessionStorage.removeItem("TPSession");
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.state.token;
        context.commit('resetState');
        window.axios
          .post(window.API.AuthenticationsSignOut)
            .then(response => {
              location.reload();
              resolve(response);
            })
            .catch(errors => {
              location.reload();
              reject(errors)
            });
        })
    },
    chceckAPIConnection() {
      return new Promise((resolve, reject) => {
        window.axios
          .get(window.axios.baseURL + "/help/index.html")
            .then(response => {
              resolve(response);
            })
            .catch(errors => {
              reject(errors)
            });
        })
    },
    refreshToken(context) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.state.token;
        axios
          .put(window.API.Authentications)
          .then(response => {
            if (response.data.isLogged) {
              sessionStorage.setItem("TPSession", JSON.stringify(response.data.token));
              context.commit('updateAuthorization', response.data);
              context.commit('updateAxiosHeader', "Bearer " + response.data.token);
              context.commit('updateAuthoriseResult', "logged");
            }
            else
            {
              context.commit('updateAuthoriseResult', "notlogged");
            }
            resolve(this.sessionAuthoriseResult);
          })
          .catch(errors => {
            reject(errors)
          }); 
      })
    },
    forgottenPassword(context, user) {
      return new Promise((resolve, reject) => {
        let data = {
          login: user.loginReset,
          addressUrl: "https://termoprofil.com.pl/pk/#/resetpassword",
          countryCode: user.country
        };
        axios
          .post(window.API.AuthenticationsForgottenPassword, data)
          .then(response => {
            resolve(response);
          })
          .catch(errors => {
            reject(errors)
          }); 
      })
    },
    resetPassword(context, user) {
      return new Promise((resolve, reject) => {
        let data = {
          login: user.login,
          newPassword: user.newPassword,
          token: user.token
        };
        axios
          .post(window.API.AuthenticationsResetPassword, data)
          .then(response => {
            resolve(response);
          })
          .catch(errors => {
            reject(errors)
          }); 
      })
    },
    newPassword(context, user) {
      return new Promise((resolve, reject) => {
        let data = {
          newPassword: user.newPassword,
          currentPassword: user.currentPassword
        };
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.state.token;
        axios
          .post(window.API.AuthenticationsNewPassword, data)
          .then(response => {
            resolve(response);
          })
          .catch(errors => {
            reject(errors)
          }); 
      })
    },
    sessionAuthorise(context) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.state.token;
        axios
          .put(window.API.Authentications, this.state.token, this.state.axiosHeader)
          .then(response => {
            if (response.data.isLogged) {
              sessionStorage.setItem("TPSession", JSON.stringify(response.data.token));
              if (response.data.privileges === this.state.privileges) { 
                context.commit('updateAuthorization', response.data);
                context.commit('updateAxiosHeader', "Bearer " + response.data.token);
                context.commit('updateAuthoriseResult', "logged");
                resolve(this.state.sessionAuthoriseResult);
              }
              else{
                context.commit('updateAuthoriseResult', "changed");
                window.Store.dispatch("logout");
                resolve(this.state.sessionAuthoriseResult);
              }
            } 
            else {
              context.commit('updateAuthoriseResult', "notlogged");
              window.Store.dispatch("logout");
              resolve(this.state.sessionAuthoriseResult);
            }
    
          })
          .catch(errors => {
            window.Store.dispatch("logout");
            reject(errors)
          }); 
      })
    },
    screenOrientation(context){
      context.commit('updateScreenOrientation');
    }
  },

  mutations: {
    changeLang(state, lang) {
      state.lang = lang
    },
    updateAuthorization(state, data) {
      state.token = data.token
      state.tokenExpires = data.tokenExpires
      state.companyName = data.companyName
      state.privileges = data.privileges
      state.personLogin = data.personLogin
      state.isLogged = data.isLogged
    },
    updateAxiosHeader(state, data) {
      state.axiosHeader.headers.Authorization = data
    },
    updateAuthoriseResult(state, data) {
      state.sessionAuthoriseResult.respond = data;
    },
    resetState(state) {
      state.token = null;
      state.tokenExpires = null;
      state.companyName = null;
      state.privileges = null;
      state.personLogin = null;
      state.isLogged = null;
      state.axiosHeader.headers.Authorization = null;
      state.sessionAuthoriseResult.respond = null;
    },
    updatePasswordReset(state, data) {
      state.sessionAuthoriseResult.respond = data;
    },
    updateScreenOrientation(state) {
      state.screenOrientation = window.screen.orientation.type;
    },
  },

  getters: {
    getLang(state) {
      return state.lang;
    },
    getIsLogged(state) {
      return state.isLogged;
    },
    getAuthoriseResult(state) {
      return state.sessionAuthoriseResult.respond;
    },
    getPriviliges(state) {
      return state.privileges;
    },
    getAxiosHeader(state) {
      return state.axiosHeader;
    },
    getCurrentUser(state) {
      return state.personLogin;
    },
    getCurrentUserIdx(state) {
      return state.personLogin.idx;
    },
    getTokenExpires(state) {
      return state.tokenExpires;
    },
    getScreenOrientation(state) {
      return state.screenOrientation;
    }
  },

})

export default Store


